module.exports = __webpack_public_path__ + "static/media/mn6.cafea045.jpeg";